$(document).ready(function(){
    getTAReview(hotelCodes)

    $('#areaSelect').change(function(){
        var path = $('#areaSelect option:selected').val();
        if(path){
            window.location.href = path
        }
    })
    $('.clickable').click(function(evt){
        window.location.href = $(evt.target).attr("link-data")
    })
});

function getTAReview(hotelCodes){
    hotelcodes = Array.isArray(hotelCodes)?hotelCodes.join(","):hotelCodes
    $.ajax({
        type: "POST",
        url: "https://stworld.jp/ta_api/get_reviews/",
        data: { hotelcodes },
        dataType: "json",
        success: function ( j ){
            if(j){
                Object.keys(j).forEach(function(code){
                    var rating = j[code]['rating']*1
                    var rating_class = "-rate_"+(rating+"").replace(".","-")
                    $('#ta_'+code).attr('class',rating_class)
                    $('#dl_ta_'+code).show()
                    var imageUrl = j[code]['rating_image_url']
                    $('#ta_img_'+code).attr('src', imageUrl)
                    var webUrl = j[code]['web_url']
                    $('#ta_url_'+code).attr('href',webUrl)
                    var numReview = j[code]['num_reviews']
                    $('#ta_num_'+code).text(numberWithCommas(numReview))
                })
            }
        },
        error : function (jqXHR, status, error){
           //do somthing
        }
    });
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}